import { render, staticRenderFns } from "./projectSale.vue?vue&type=template&id=15ce1d44&scoped=true&"
import script from "./projectSale.vue?vue&type=script&lang=js&"
export * from "./projectSale.vue?vue&type=script&lang=js&"
import style0 from "./projectSale.vue?vue&type=style&index=0&id=15ce1d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce1d44",
  null
  
)

component.options.__file = "projectSale.vue"
export default component.exports